import Base from "../base";

export default class IdiomaServices extends Base {
  static endpointUrl = "encuestas/idiomas/";
}
